"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecatedProp;
var warned = {};

/**
 * See https://reactjs.org/warnings/dont-call-proptypes.html
 */
function deprecatedProp(propType, explanation) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  // the param _ has always the same value ("props") and since it's never used no specific name was given
  // and it's used this way so we can retrieve the value of nestedParam in a easy way
  // otherwise it'd be necessary manipulate a list to get nestedParam value
  return function deprecated(props, propName, componentName, _, nestedPropName) {
    // `mainPropName` is useful in case of nested properties like when a property receive a JSON
    // when there's no nested property, the mainPropName is already provided by propName
    var mainPropName = nestedPropName && ".".concat(nestedPropName.split('.')[0]) || '';
    if (typeof props[propName] !== 'undefined') {
      var message = "@veneer/core: `".concat(propName, "` property of `").concat(componentName).concat(mainPropName, "` has been deprecated.\n").concat(explanation);
      if (error) {
        throw new Error(message);
      }
      if (!warned[message]) {
        console.warn(message);
        warned[message] = true;
      }
    }
    for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }
    return propType.apply(void 0, [props, propName, componentName, _, nestedPropName].concat(rest));
  };
}